import { render, staticRenderFns } from "./DehorningEdit.vue?vue&type=template&id=ac7515b8&scoped=true&"
import script from "./DehorningEdit.vue?vue&type=script&lang=js&"
export * from "./DehorningEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac7515b8",
  null
  
)

export default component.exports